import { gql } from '@apollo/client';
import { SELECT_OPTION_FIELDS } from '../../types/SelectOptionType';

export const GET_SETTLEMENT_CLIENT_BY_ROLE = gql`
    query GetSettlementClientByRole($roleType: Int) {
        getAllSettlementClient(roleType: $roleType) {
            ...SelectOptionFields
        }
    }
    ${SELECT_OPTION_FIELDS}
`;

export interface GetSettlementClientByRoleResponse {
    getAllSettlementClient: Array<{ value: string; label: string }>;
}
